// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Dkpb","filesListContainer":"PosDisputesFiles_filesListContainer__1XCxK","filesButton":"PosDisputesFiles_filesButton__3k72F"};